import { Locale } from 'modules/i18n';

export const informationTranslation = {
  [Locale.en]: {
    requestsTitle: 'Requests ({value})',
    requestsValue: '{value, number, ::compact-short}',
    noData: 'No requests yet',
  },
};
